import { OptionalString } from '@/app/core';
import * as yup from 'yup';
import { parse as parseDateFn } from 'date-fns';

type TransformFunction<TIn> = (input: TIn) => TIn;

const identityFn = <TIn>(input: TIn): TIn => input;

export interface DateValidationConfig {
  formatValidationRegex: RegExp;
  postFormatValidationTransformFn: TransformFunction<string>;
}

export const defaultDateValidationConfig = {
  postFormatValidationTransformFn: identityFn,
};

const DateFormatSchema = (
  formatForMessage: string,
  dateFormats: string[],
  config: DateValidationConfig,
): yup.StringSchema<string | undefined> => {
  return (
    yup
      .string()
      // .transform(effectiveConfig.postFormatValidationTransformFn)
      .test({
        name: 'IsValidDate',
        test(rawValue: OptionalString) {
          if (!rawValue) {
            return true;
          } else {
            const value = rawValue.trim();
            const isFormatValid = config.formatValidationRegex.test(value);
            // console.log(isFormatValid, config.formatValidationRegex, value);
            if (!isFormatValid) {
              // console.log(`${value} is not in valid format.`);
              return this.createError({
                message: `${value} is not in valid format.`,
              });
            }

            const normalizedDateValue = config
              .postFormatValidationTransformFn(value)
              .replace(/[\\/-\s,.]/gi, ' ')
              .replace(/\s+/gi, ' ');

            const isValid = dateFormats.some(
              (a) =>
                parseDateFn(normalizedDateValue, a, new Date()).toString() !==
                'Invalid Date',
            );

            // if (!isValid) {
            //   console.log(
            //     `NM: ${normalizedDateValue}|${dateFormats}} => ${isValid}`,
            //   );
            // }

            if (isValid) {
              return true;
            } else {
              return this.createError({
                message: `${value} is not valid and should in the format ${formatForMessage}.`,
              });
            }
          }
        },
      })
  );
};
export { DateFormatSchema };
